.edit-preset-modal {
  width: 445px;
}
